import { KeyValuePairOfStringAndString } from '@lib/graphql/graphql'

export const getTrackingProductId = (
  productId?: string,
  metadata?: KeyValuePairOfStringAndString[],
) => {
  const oldProductId = metadata?.find((m) => m.key === 'OLD_PRODUCT_ID')
  return oldProductId?.value || productId
}
